import { GOOGLE_ANALYTICS_TAG, PORTFOLIO_CONTEXT } from './constants';
import PortfolioView from '../../components/Portfolio';
import PortfolioGraphing from './PortfolioGraphing';
import React from 'react';
import { portfolioAnalysisTutorialSteps } from './tutorialSteps';
import { defaultBasicFilterTypes } from '../../components/Filters/filterTypes';

const PortfolioAnalysis = () => {
  return (
    <PortfolioView
      basicFilterTypes={defaultBasicFilterTypes}
      context={PORTFOLIO_CONTEXT}
      googleAnalyticsTag={GOOGLE_ANALYTICS_TAG}
      GraphingComponent={PortfolioGraphing}
      tutorialSteps={portfolioAnalysisTutorialSteps}
    />
  );
};

export default PortfolioAnalysis;
